import React, { useRef , useState }  from "react";
import { createRoot } from "react-dom/client"; // <-- IMPORT arriba
import PlayerDropboxNew from './PlayerDropboxNew'
import { useTranslation } from 'react-i18next';
import tutovehicle01 from "../images/tutovehicle01.png";
import vehicleNew1 from "../images/vehicleNew1.png";
import tutovehicle02 from "../images/tutovehicle02.png";
import vehicleNew2 from "../images/vehicleNew2.png";
import tutovehicle03 from "../images/tutovehicle03.png";
import vehicleNew3 from "../images/vehicleNew3.png";

import tutovehicle04 from "../images/tutovehicle04.png";
import tutovehicle05 from "../images/tutovehicle05.png";
import tutovehicle06 from "../images/tutovehicle06.png";
import tutovehicle07 from "../images/tutovehicle07.png";
import tutovehicle08 from "../images/tutovehicle08.png";
import tutovehicle09 from "../images/tutovehicle09.png";
import tutovehicle10 from "../images/tutovehicle10.png";
import vehicleNew4 from "../images/vehicleNew4.png";
import spawnNewWeb from "../images/spawnNewWeb.png";
import spawnNew from "../images/spawnNew.png";
import tpsNewWeb from "../images/tpsNewWeb.png";
import tpsNew from "../images/tpsNew.png";
import spacialNewWeb from "../images/spatialNewWeb.png";
import spacialNew from "../images/spatialNew.png";
import vehicleNew from "../images/vehicleNew.png";
import vehicleNewWeb from "../images/vehicleNewWeb.png";

function MainNew(){
const { t, i18n } = useTranslation();
const containerRefReel = useRef(null);
const imageContainerRef = useRef(null);
const containerRef = useRef(null);
const containerImplementationRef = useRef(null);
const section2Ref = useRef(null);
const [fadeOut, setFadeOut] = useState(false);


const handleClick = () => {
  
    if (containerRefReel.current) {
 
      containerRefReel.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRefReel.current); // renderiza el video
      root.render(<PlayerDropboxNew source =  {t("ReelLink")}/>);
    }
    setFadeOut(true);
  };
   
const handleArrowClick = () => {
  section2Ref.current.scrollIntoView({
    behavior: "smooth",
    block: "start", // 👈 CLAVE
  });
};

const handleClickInside = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = " video-main-container-games  mt-5" ><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/gqiptf1kgbt3mox2zxi6b/InsideCredits.mp4?rlkey=gjkvq9hurs9l54c0qtcsq6888&st=tazc1to7&dl=0"/></div>);
     
      containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
   
  };
   
const handleClickLords = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/8ggwggzgczflehd7m0564/Aftertouch-Audio-Sound-Design-Contest_Cecilia-Garcia.m4v?rlkey=qzski437fumjb2ixlcwd2p7ng&st=n2zizuwh&dl=0"/></div>);
   
      containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
   
    }
   
  };

const handleClickOver = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/0h2n36bvykhz4y580mn1j/Overwatch-2-Sojourn.mp4?rlkey=dksw1s4z7dbncbr9dh4whlyd1&st=vs0uzu30&dl=0"/></div>);
  
        containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

const handleClickNfs = () => {
  if (containerRef.current) {
    const root = createRoot(containerRef.current);

    root.render(
      <div className="video-main-container-games  mt-5">
        <PlayerDropboxNew source="https://www.dropbox.com/scl/fi/dts6xixicazlihkeak82a/NeedForSpeed.mp4?rlkey=in8hgau7voemigk6vx2tf7re1&st=2uh1aurf&dl=0" />
      </div>
    );

    // 👇 esperar a que el DOM tenga el alto real
    requestAnimationFrame(() => {
      scrollContainerToCenter(containerRef.current);
    });
  }
};

  const handleClickImpTps = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/vtgm1bwyoh3b2hde12uiw/TPS-DEMO-LOCU.mp4?rlkey=817pgv0302klwqbyo1d6uto85&st=zvkz5x4v&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };


  const handleClickImpSpacial = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/pjbigcpkkup07cuh9y6qv/SpatialAudioImp.mp4?rlkey=lhyefwinx7vn8kjoyz4x7zfyo&st=tfa40r91&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

    const handleClickImpVehicleP1 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/6oykbta0f51rhsjvyurc0/tuto-engine-P1.mp4?rlkey=f53g2971ubf1uq8e9xm4nh7om&st=x4fdgqqi&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

      const handleClickImpVehicleP2 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/82cnost4dup1ds6ddzmgz/tuto-engine-P2.mp4?rlkey=fe3yaprewpons0e5wrn6j14na&st=ibrjohsd&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

      const handleClickImpVehicleP3 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/ibwsl6huj8hhbbak0wuyu/tuto-engine-p3.mp4?rlkey=2f6rvsvj1945i4vkq4sgm5y97&st=0bvy49ux&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

      const handleClickImpVehicleP4 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/xmeg34adblek1oxdch0z9/tuto-engine-P4.mp4?rlkey=lj0rx9wrb2olohbxvhldmui5a&st=tx6v8d97&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP5 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://youtu.be/bHDkYYp_sjYhttps://www.dropbox.com/scl/fi/nr125gk7gy6qmdkrlymwn/tuto-engine-P5.mp4?rlkey=6bh7pkcv8hjquky5o2jdkrf2e&st=k7yk0n92&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP6 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/kom5yy0l74td720blfmei/tuto-engine-P6-Suspension-MS.mp4?rlkey=tgc05wmwwjkqcmysd7ec3h0jd&st=i7hne5al&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP7 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/eb9otimcf48b32ht2nmaq/tuto-engine-P7.mp4?rlkey=54t5uborl8dzu5ektw5xp9xwe&st=ztcmkgrf&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP8 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/rukf5xp0dolfaptakuwm6/tuto-engine-P8-skids-part-1.mp4?rlkey=ah3beomn2rpryr7ml0fw85c5p&st=hzlvya1c&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP9 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://youtu.be/hm8pM9BCCTM"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

        const handleClickImpVehicleP10 = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://youtu.be/CoxT_FvXa7c"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
  };

   const handleClickVehicle = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container-games  mt-5"><PlayerDropboxNew source="https://youtu.be/ADJeqDLL7eE"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

  const scrollContainerToCenter = (element) => {
  if (!element) return;

  const elementTop = element.offsetTop;
  const elementHeight = element.offsetHeight;
  const viewportHeight = window.innerHeight;

  const targetScroll =
    elementTop - (viewportHeight / 2) + (elementHeight / 2);

  window.scrollTo({
    top: Math.max(0, targetScroll),
    behavior: "smooth",
  });
};

    return(
                  <div className="overlay-content main-video" >
                  
              {/* REEL */}

                    <div className="flex-grow-1 pb-2 pb-md-4 main-text">
                      <h1 style={{  fontFamily: 'LeagueGothic' }} className="tittle-text mb-1 ">CECILIA GARCIA</h1>
                      
                      <p  style={{  fontFamily: 'Lato' }}  className=" masthead-subheading mastheadsubt font-face-francois  mb-0 subtittle-text">{t('Sound Designer')}</p>
                     

                  <div
                      className="mb-4 mt-4 video-main-container-reel"
                      ref={containerRefReel}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {/* Imagen principal */}
                      <img
                        
                        className="click-to-video"
                        src={t("ReelPic")}
                        alt=""
                        style={{
                          cursor: "pointer",
                          width: "100%",
                          height: "100%",
                          transition: "opacity 0.5s ease",
                          opacity: fadeOut ? 0 : 1,
                          pointerEvents: fadeOut ? "none" : "auto",
                          display: "block"
                        }}
                        onClick={handleClick}
                      />

                      {/* Flecha/play */}
                      <div className="hover-arrow ">
                        <i className="fas fa-play fa-3x"></i>
                      </div>
                      
                  </div>

                    <div className="row align-items-center p-4 pb-10 arrow justify-content-center">
                      <div onClick={handleArrowClick} className="icon-wrapper" >
                       <i   className="fa fa-angle-double-down " aria-hidden="true"></i>
                      </div>
                    </div>
                    
                  </div>


                    {/* section 2 */}


                  <div className="row align-items-center p-4 arrow justify-content-center">
                    
                    <div className="sectionText">

                    <div className="row align-items-start p-4">

                   {/* implementation */}
                   <div className="col-12 col-lg-6">

                    <div className="sectionText" ref={section2Ref}>
                      <h2 style={{ fontFamily: 'LeagueGothic' }} className="pb-0 page-section-heading text-center text-uppercase title mb-0">
                        {t('GamesSubt2')}
                      </h2> 
                    </div>
                    
                    <div className = "mb-4" ref={containerImplementationRef}></div>
                    
                  <div className = "video-main-container-games mt-2" >
                    <div class="row g-3 pb-4 justify-content-center">

                        {/* Tuto Vehicle 1 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle01})`,
                                  "--imageMobile": `url(${tutovehicle01})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP1}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt1")}</p>
                              </div>
                            </div>
                          </div>

                          {/* Tuto Vehicle 2 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle02})`,
                                  "--imageMobile": `url(${tutovehicle02})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP2}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt2")}</p>
                              </div>
                            </div>
                          </div>

                           {/* Tuto Vehicle 3 */}
                          {/* <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle03})`,
                                  "--imageMobile": `url(${tutovehicle03})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP3}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt3")}</p>
                              </div>
                            </div>
                          </div>



                           {/* Tuto Vehicle 4 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle04})`,
                                  "--imageMobile": `url(${tutovehicle04})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP4}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt4")}</p>
                              </div>
                            </div>
                          </div>

                          {/* Tuto Vehicle 5 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle05})`,
                                  "--imageMobile": `url(${tutovehicle05})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP5}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt5")}</p>
                              </div>
                            </div>
                          </div>

                          
                           {/* Tuto Vehicle 6 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle06})`,
                                  "--imageMobile": `url(${tutovehicle06})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP6}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt6")}</p>
                              </div>
                            </div>
                          </div>


                          {/* Tuto Vehicle 7 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle07})`,
                                  "--imageMobile": `url(${tutovehicle07})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP7}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt7")}</p>
                              </div>
                            </div>
                          </div>

                          {/* Tuto Vehicle 8 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle08})`,
                                  "--imageMobile": `url(${tutovehicle08})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP8}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt8")}</p>
                              </div>
                            </div>
                          </div>


                           {/* Tuto Vehicle 9 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle09})`,
                                  "--imageMobile": `url(${tutovehicle09})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP9}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt9")}</p>
                              </div>
                            </div>
                          </div>


                           {/* Tuto Vehicle 10 */}
                         {/*  <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tutovehicle10})`,
                                  "--imageMobile": `url(${tutovehicle10})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicleP10}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow" >
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("TutoEngineTitle")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("TutoEngineSubt10")}</p>
                              </div>
                            </div>
                          </div>

*/}
                      <h4 style={{ fontFamily: 'Lato' }} className=" mt-4 page-section-heading text-center text-uppercase title mb-0">
                        {t('GamesSubt5')}
                      </h4> 

                        {/* vehicle - dropbox cigfernandez2*/}
                          <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${vehicleNewWeb})`,
                                  "--imageMobile": `url(${vehicleNew})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickVehicle}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("GamesBreakTitle2")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("GamesBreakSubt2")}</p>
                              </div>
                            </div>
                          </div>
                          
                      <h4 style={{ fontFamily: 'Lato' }} className=" mt-4 page-section-heading text-center text-uppercase title mb-0">
                        {t('GamesSubt6')}
                      </h4> 

                          {/* TPS - dropbox cigfernandez2*/}
                          <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tpsNewWeb})`,
                                  "--imageMobile": `url(${tpsNew})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpTps}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesBreakTitle3')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesBreakSubt3')}</p> 
                              </div>
                            </div>
                          </div>

                          
                           {/* SPATIAL - dropbox cigfernandez2*/}

                          <div
                            className="videos-container col-12"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${spacialNewWeb})`,
                                  "--imageMobile": `url(${spacialNew})`,
                              
                              }}>
                                
                            <div className="ratio  bg-dark text-white" style={{ aspectRatio: "16 / 4" }}>
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpSpacial}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("GamesBreakTitle4")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("GamesBreakSubt4")}</p>
                              </div>
                            </div>

                          </div>
                      </div>
                    </div> 
                  </div>
                  

                      {/*  SOUND DESIGN */}
                      <div className="col-12 col-lg-6">
                    <div className="sectionText mt-5 mt-lg-0">
                          <h2 style={{ fontFamily: 'LeagueGothic' }} className="page-section-heading text-center text-uppercase title pt-4 pt-lg-0 mb-0">
                          {t('GamesSubt1')}</h2> 
                    </div>
                    <div className = "" ref={containerRef}></div>
                    
                    <div className = "video-main-container-games  game-design-container" >
                      

                        <div class="row g-3 pb-3">
                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container firstsdcontainer col-12" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/overNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickOver}        
                              />
                           </div>
                                                         {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle3')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt3')}</p> 
                              </div>    
                            </div>
                          </div>

                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/nfsNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickNfs}        
                              />
                            </div>
                                                          {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle4')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt4')}</p> 
                              </div>                                
                            </div>
                          </div>
                      </div>


                    <div class="row g-3 ">
                            <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12" >
                            <div className="ratio ratio-16x9 bg-dark text-white" >
                              <img  class="click-to-video"
                                  src="./images/insideNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickInside}        
                              />                                   
                           </div>
                              {/* Flecha/play */}
                            <div className="hover-arrow"  >
                              <i className="fas fa-play fa-3x "></i>
                            
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle1')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt1')}</p> 
                              </div>    
                           
                            </div>
                  
                          </div> 

                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/lordsNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickLords}        
                              />
                            </div>
                                                          {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle2')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt2')}</p> 
                              </div>   

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    </div>
                  </div>{/* end row */}
                </div>

    )
}
export default MainNew
